// import React from "react";
// import PP from "../../assets/privacyImage.jpeg";
// import { Helmet } from "react-helmet-async";

// const PrivacyPolicy = () => {
//   const sections = [
//     {
//       title: "Introduction",
//       content:
//         "Welcome to LMS Bots. LMS Bots is a Lead Management System designed to help users efficiently create, manage, and track sales leads. This application enables users to maintain lead records, update information, monitor call activities, and manage notes in a streamlined manner. We value your privacy and are committed to protecting your personal data.",
//     },
//     {
//       title: "Information We Collect",
//       content: `We may collect and store the following types of information:

// • Personal Information: Name, phone number, company name, profile image  
// • Lead Data: Contact details, notes, lead status, activity history  
// • Call Log Data (with permission): Incoming, outgoing, and missed calls  
// • Device Information: Basic device-related information`,
//     },
//     {
//       title: "Call Log Permission Usage",
//       content: `LMS Bots may request access to call logs to enhance lead tracking:

// • Used only for saved lead numbers  
// • Tracks incoming, outgoing, missed calls  
// • No access to unrelated call history  
// • No external storage or sharing  
// • Permission is optional`,
//     },
//     {
//       title: "How We Use Your Information",
//       content: `We use collected data to:

// • Create and manage accounts  
// • Store and organize lead data  
// • Provide call insights  
// • Enable notes and updates  
// • Send notifications  
// • Improve performance`,
//     },
//     {
//       title: "Data Storage and Security",
//       content:
//         "We implement appropriate technical measures to protect your data. Data is securely stored on our servers, and access is restricted to prevent unauthorized use.",
//     },
//     {
//       title: "Data Sharing and Disclosure",
//       content:
//         "We do not sell or rent your data. Information is only shared if required by law or legal authorities.",
//     },
//     {
//       title: "User Rights",
//       content: `You have the right to:

// • Access your data  
// • Update or correct information  
// • Request deletion of your data`,
//     },
//     {
//       title: "Children's Privacy",
//       content:
//         "LMS Bots is not intended for children under 13. We do not knowingly collect data from children.",
//     },
//     {
//       title: "Changes to This Policy",
//       content:
//         "We may update this Privacy Policy from time to time. Users are encouraged to review it periodically.",
//     },
//     {
//       title: "Contact Us",
//       content: (
//         <>
//           For any questions or requests, please contact us via:{" "}
//           <a
//             href="https://deetyasoft.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="text-blue-600 underline hover:text-blue-800"
//           >
//             https://deetyasoft.com
//           </a>
//         </>
//       ),
//     },
//   ];

//   return (
//     <>
//       {/* ✅ SEO START */}
//       <Helmet>
//         <title>Privacy Policy | LMSBots</title>

//         <meta
//           name="description"
//           content="Read the LMSBots Privacy Policy to understand how we collect, use, and protect your personal data and lead information."
//         />

//         <meta
//           name="keywords"
//           content="LMSBots privacy policy, CRM privacy, lead management data security, SaaS privacy policy"
//         />

//         <meta name="author" content="LMSBots" />

//         {/* Open Graph */}
//         <meta property="og:title" content="Privacy Policy | LMSBots" />
//         <meta
//           property="og:description"
//           content="Learn how LMSBots protects your data, handles lead information, and ensures privacy."
//         />
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content="https://lmsbots.com/privacy-policy" />

//         {/* Twitter */}
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:title" content="Privacy Policy | LMSBots" />
//         <meta
//           name="twitter:description"
//           content="Understand LMSBots data privacy practices and security measures."
//         />

//         {/* Canonical */}
//         <link rel="canonical" href="https://lmsbots.com/privacy-policy" />
//       </Helmet>

//       {/* Header */}
//       <div
//         className="relative text-center mb-3 py-44 w-full bg-cover bg-center bg-no-repeat"
//         style={{ backgroundImage: `url(${PP})` }}
//       >
//         <div className="absolute inset-0 bg-black opacity-25"></div>
//       </div>

//       {/* Title */}
//       <div className="md:py-5 py-2 text-center">
//         <h2 className="text-2xl sm:text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-2 md:mb-4">
//           Privacy Policy
//         </h2>
//         <div className="w-20 md:w-40 h-1 mx-auto bg-main rounded mb-3" />
//       </div>

//       {/* Content */}
//       <div className="bg-light rounded-lg md:p-4 p-2 shadow-lg">
//         <div className="flex flex-col md:flex-row gap-8">
//           {/* Sidebar */}
//           <div className="w-full md:w-1/4 lg:sticky lg:top-14 lg:h-[500px] overflow-y-auto bg-white rounded-lg p-6 shadow-md">
//             <h2 className="text-xl font-semibold text-main mb-4">
//               Table of Contents
//             </h2>
//             <div className="space-y-3">
//               {sections.map((item, index) => (
//                 <button
//                   key={index}
//                   onClick={() => {
//                     const el = document.getElementById(`section-${index}`);
//                     if (el) el.scrollIntoView({ behavior: "smooth" });
//                   }}
//                   className="block text-left w-full text-gray-700 hover:text-primary text-sm"
//                 >
//                   {index + 1}. {item.title}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* Main Content */}
//           <div className="w-full md:w-3/4 space-y-6">
//             {sections.map((section, index) => (
//               <div key={index}>
//                 <h4
//                   id={`section-${index}`}
//                   className="text-main md:text-xl text-lg font-semibold"
//                 >
//                   {section.title}
//                 </h4>
//                 <p className="text-gray-600 text-sm md:text-base mt-2 whitespace-pre-line">
//                   {section.content}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default PrivacyPolicy;








import React from "react";
import PP from "../../assets/privacyImage.jpeg";
import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";
import { ROUTES } from "../../seoData";

const PATH = "/privacy-policy";
const TITLE = ROUTES[PATH].title;
const DESCRIPTION = ROUTES[PATH].description;

const SECTIONS = [
  {
    id: "introduction",
    title: "Introduction",
    body: (
      <p>
        Welcome to <strong>LMSBOTS</strong>. LMSBOTS is a Lead Management System
        designed to help users create, manage, and track sales leads. The
        application lets you maintain lead records, update information, monitor
        call activity, and manage notes in a streamlined way. We value your
        privacy and are committed to protecting your personal data.
      </p>
    ),
  },
  {
    id: "information-we-collect",
    title: "Information we collect",
    body: (
      <>
        <p>We may collect and store the following types of information:</p>
        <ul className="mt-3 list-disc space-y-2 pl-5">
          <li>
            <strong>Personal information</strong> — name, phone number, company
            name, and profile image.
          </li>
          <li>
            <strong>Lead data</strong> — contact details, notes, lead status,
            and activity history.
          </li>
          <li>
            <strong>Call log data (with permission)</strong> — incoming,
            outgoing, and missed calls.
          </li>
          <li>
            <strong>Device information</strong> — basic device-related
            information used to run the service.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "call-log-permission",
    title: "Call log permission usage",
    body: (
      <>
        <p>LMSBOTS may request access to call logs to improve lead tracking:</p>
        <ul className="mt-3 list-disc space-y-2 pl-5">
          <li>Used only for saved lead numbers.</li>
          <li>Tracks incoming, outgoing, and missed calls.</li>
          <li>No access to unrelated call history.</li>
          <li>No external storage or sharing of call logs.</li>
          <li>The permission is optional and can be revoked at any time.</li>
        </ul>
      </>
    ),
  },
  {
    id: "how-we-use-information",
    title: "How we use your information",
    body: (
      <>
        <p>We use the data we collect to:</p>
        <ul className="mt-3 list-disc space-y-2 pl-5">
          <li>Create and manage accounts.</li>
          <li>Store and organize lead data.</li>
          <li>Provide call insights for saved leads.</li>
          <li>Enable notes and updates across your team.</li>
          <li>Send notifications related to your account.</li>
          <li>Improve performance, reliability, and security.</li>
        </ul>
      </>
    ),
  },
  {
    id: "data-storage-and-security",
    title: "Data storage and security",
    body: (
      <p>
        We implement appropriate technical measures to protect your data. Data
        is securely stored on our servers and access is restricted to prevent
        unauthorized use. Where practical, we use encryption in transit and
        role-based access controls.
      </p>
    ),
  },
  {
    id: "data-sharing-and-disclosure",
    title: "Data sharing and disclosure",
    body: (
      <p>
        We do not sell or rent your data. Information is only shared where
        required by law, or with legal authorities following a valid legal
        request.
      </p>
    ),
  },
  {
    id: "user-rights",
    title: "Your rights",
    body: (
      <>
        <p>You have the right to:</p>
        <ul className="mt-3 list-disc space-y-2 pl-5">
          <li>Access your data.</li>
          <li>Update or correct information.</li>
          <li>Request deletion of your data.</li>
        </ul>
      </>
    ),
  },
  {
    id: "childrens-privacy",
    title: "Children's privacy",
    body: (
      <p>
        LMSBOTS is not intended for children under 13, and we do not knowingly
        collect data from children.
      </p>
    ),
  },
  {
    id: "changes-to-this-policy",
    title: "Changes to this policy",
    body: (
      <p>
        We may update this Privacy Policy from time to time. Users are
        encouraged to review it periodically. When we make material changes we
        will update the effective date on this page.
      </p>
    ),
  },
  {
    id: "contact-us",
    title: "Contact us",
    body: (
      <p>
        For any questions or requests about this policy or your data, please
        contact us at {" "}
        <a
          href="support@deetyasoft.com"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-[#48247f] underline decoration-[#702cb0]/40 underline-offset-2 hover:text-[#702cb0]"
        >
          support@deetyasoft.com
        </a>
        .
      </p>
    ),
  },
];

const JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${SITE_URL}${PATH}#webpage`,
    url: `${SITE_URL}${PATH}`,
    name: TITLE,
    description: DESCRIPTION,
    inLanguage: "en-IN",
    isPartOf: { "@id": `${SITE_URL}/#website` },
    about: { "@id": `${SITE_URL}/#organization` },
    primaryImageOfPage: { "@type": "ImageObject", url: `${SITE_URL}/og-image.png` },
    breadcrumb: { "@id": `${SITE_URL}${PATH}#breadcrumb` },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": `${SITE_URL}${PATH}#breadcrumb`,
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: "Privacy Policy", item: `${SITE_URL}${PATH}` },
    ],
  },
];

const PrivacyPolicy = () => {
  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />

      <div
        className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased"
      >
        {/* ================= HERO ================= */}
        <section
          aria-labelledby="privacy-heading"
          className="relative isolate w-full overflow-hidden bg-gradient-to-b from-[#f6f3fc] via-white to-white"
        >
          <div
            className="pointer-events-none absolute inset-0 -z-10 opacity-40"
            style={{
              backgroundImage: "radial-gradient(#48247f18 1px, transparent 1px)",
              backgroundSize: "22px 22px",
              WebkitMaskImage: "radial-gradient(ellipse at 40% 40%, black 30%, transparent 80%)",
              maskImage: "radial-gradient(ellipse at 40% 40%, black 30%, transparent 80%)",
            }}
          />
          <div className="pointer-events-none absolute -right-24 -top-24 -z-10 h-72 w-72 rounded-full bg-[#702cb0]/10 blur-3xl sm:h-96 sm:w-96" />
          <div className="pointer-events-none absolute -left-24 bottom-0 -z-10 h-64 w-64 rounded-full bg-[#12dfbd]/12 blur-3xl sm:h-80 sm:w-80" />

          <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-20 sm:gap-12 sm:px-8 sm:pb-16 sm:pt-24 md:px-10 lg:grid-cols-[1.05fr_1fr] lg:gap-14 lg:px-14 lg:pb-24 lg:pt-32 xl:px-20">
            <div className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left">
              <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-[11px] font-medium text-[#48247f] shadow-sm sm:mb-6 sm:text-xs">
                <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#12dfbd]" />
                Legal · LMSBOTS
              </div>

              <h1
                id="privacy-heading"
                className="text-balance text-[26px] font-light leading-[1.2] tracking-tight sm:text-[32px] md:text-[36px] lg:text-[40px] xl:text-[44px]"
              >
                Privacy{" "}
                <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                  Policy
                </span>
              </h1>

              <p className="mx-auto mt-4 max-w-[560px] text-sm font-light leading-[1.75] text-[#3b2a63] sm:text-base lg:mx-0 lg:text-[17px]">
                How LMSBOTS collects, uses, and protects the data you and your
                team put into the platform. Plain-language summary, with the
                full policy below.
              </p>

              <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-medium text-[#3b2a63] sm:text-xs lg:justify-start">
                <li className="inline-flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-[#0f9d86]" />
                  Last updated: this page reflects the current published policy
                </li>
              </ul>
            </div>

            <div className="relative mx-auto w-full max-w-[600px] px-3 pb-6 pt-3 lg:max-w-none">
              <div className="absolute inset-x-8 bottom-0 top-10 rounded-3xl bg-[#e3faf5]" />
              <div className="relative rounded-2xl bg-white p-2 shadow-xl ring-1 ring-slate-200">
                <img
                  src={PP}
                  alt="LMSBOTS privacy and data protection"
                  width="1200"
                  height="800"
                  fetchPriority="high"
                  decoding="async"
                  className="h-auto w-full rounded-xl border border-slate-200 object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* ================= BODY ================= */}
        <section
          aria-labelledby="privacy-body-heading"
          className="relative w-full bg-white py-12 sm:py-16 lg:py-20"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-8 md:px-10 lg:px-14">
            <div className="grid gap-8 lg:grid-cols-12 lg:gap-12">
              {/* Sidebar / table of contents */}
              <aside
                aria-label="Table of contents"
                className="lg:col-span-4 lg:sticky lg:top-24 lg:self-start"
              >
                <div className="rounded-2xl border border-[#48247f]/10 bg-white p-5 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.22)] sm:p-6">
                  <h2 className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#702cb0]/80">
                    On this page
                  </h2>
                  <ol className="mt-3 space-y-1.5">
                    {SECTIONS.map((s, i) => (
                      <li key={s.id}>
                        <a
                          href={`#${s.id}`}
                          className="group flex items-start gap-2 rounded-md px-2 py-1.5 text-sm text-[#3b2a63] transition-colors hover:bg-[#f6f3fc] hover:text-[#48247f] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#702cb0] focus-visible:ring-offset-2"
                        >
                          <span className="mt-0.5 text-[11px] font-semibold text-[#702cb0]/70">
                            {String(i + 1).padStart(2, "0")}
                          </span>
                          <span className="leading-snug">{s.title}</span>
                        </a>
                      </li>
                    ))}
                  </ol>
                </div>
              </aside>

              {/* Sections */}
              <div className="lg:col-span-8">
                <div className="rounded-2xl border border-[#48247f]/10 bg-white p-5 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.22)] sm:p-8 lg:p-10">
                  <h2
                    id="privacy-body-heading"
                    className="text-balance text-[22px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[26px] md:text-[30px]"
                  >
                    The full{" "}
                    <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                      policy
                    </span>
                  </h2>
                  <p className="mt-2 text-sm leading-[1.75] text-[#3b2a63]">
                    Each section below explains one part of how LMSBOTS handles
                    data. Use the sidebar to jump to a topic.
                  </p>

                  <div className="mt-8 space-y-8">
                    {SECTIONS.map((s, i) => (
                      <article
                        key={s.id}
                        id={s.id}
                        aria-labelledby={`${s.id}-heading`}
                        className="scroll-mt-24"
                      >
                        <h3
                          id={`${s.id}-heading`}
                          className="text-lg font-medium tracking-tight text-[#28194f] sm:text-xl"
                        >
                          <span className="mr-2 text-[11px] font-semibold align-top text-[#702cb0]/70">
                            {String(i + 1).padStart(2, "0")}
                          </span>
                          {s.title}
                        </h3>
                        <div className="mt-2 text-sm leading-[1.8] text-[#3b2a63] sm:text-[15px]">
                          {s.body}
                        </div>
                      </article>
                    ))}
                  </div>
                </div>

                {/* Footer note */}
                <p className="mt-6 text-center text-xs text-slate-500 sm:text-sm">
                  Questions about this policy?{" "}
                  <a
                    href="mailto:info@deetyasoft.com"
                    className="font-medium text-[#48247f] hover:underline"
                  >
                    Email our team
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;